import { render, staticRenderFns } from "./BlockEditoCreateSocialNetwork.vue?vue&type=template&id=0ba54dac&"
import script from "./BlockEditoCreateSocialNetwork.vue?vue&type=script&lang=js&"
export * from "./BlockEditoCreateSocialNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports